import NiceModal from "@ebay/nice-modal-react";
import FlexChild from "layouts/flex/FlexChild";
import ModalBase from "modals/base/ModalBase";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import style from "./CustomerStatusModal.module.css";
import { style as buttonStyle } from "components/buttons/AdminCustomButton";
import { adminRequester } from "App";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { Container, Tooltip } from "@mui/material";
import { CButton, CSpinner } from "@coreui/react";
import AdminCustomButton from "components/buttons/AdminCustomButton";
import P from "components/P";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import InputText from "components/inputs/InputText";
import AdminInputImage from "components/inputs/image/AdminInputImage";
import AdminImage from "components/Image/AdminImage";
import ToolTip from "components/tooltip/tooltip";
import FlexGrid from "layouts/flex/FlexGrid";
import Inline from "layouts/container/Inline";

const CustomerStatusModal = NiceModal.create((props) => {
  const { t } = useTranslation();
  const { data, onSuccess } = props;
  const inputs = useRef([]);
  const [withHeader, withFooter] = [true, false];
  const [width, height] = ["min(95%, 2000px)", "80vh"];
  const withCloseButton = true;
  const clickOutsideToClose = true;
  const modal = useRef();
  const title = "고객 정보";
  const buttonText = t("close");
  const [isMounted, setMounted] = useState(false);
  const [orders, setOrders] = useState([]);
  const [limit, setLimit] = useState(20);
  const [logs, setLogs] = useState([]);
  const [reload, setReload] = useState(false);
  // const [offset, setOffset] = useState(0);
  const [page, setPage] = useState(0);
  const [max, setMax] = useState(0);
  const [folds, setFolds] = useState([false, false, false, false]);
  useEffect(() => {
    setMounted(true);
    adminRequester.getLogs(
      {
        search: data.email,
        type: "포인트",
      },
      ({ logs }) => setLogs(logs)
    );
  }, [isMounted]);
  useEffect(() => {
    if (isMounted && reload) {
      adminRequester.getLogs(
        {
          search: data.email,
          type: "포인트",
        },
        ({ logs }) => setLogs(logs)
      );
      setReload(false);
    }
  }, [reload]);
  useEffect(() => {
    if (isMounted) {
      adminRequester.getCustomerOrder(
        data.id,
        { limit: limit, offset: page * limit },
        ({ orders, count }) => {
          setOrders(orders);
          setMax(Math.ceil(count / limit));
        }
      );
    }
  }, [isMounted, page, limit]);

  const onCloseClick = () => {
    modal.current.close();
  };
  const getDate = (date) => {
    date = new Date(date);
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(date.getDate()).padStart(2, "0")} ${String(
      date.getHours()
    ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
  };
  const headers = [
    { width: 30, text: "No.", Cell: ({ index }) => index + page * limit + 1 },
    {
      width: 120,
      text: "주문일/결제일",
      Cell: ({ row }) => (
        <VerticalFlex>
          <P>{getDate(row.created_at)}</P>
          <P>
            {row?.payments?.[0]?.created_at
              ? getDate(row.payments[0].created_at)
              : "정보 없음"}
          </P>
        </VerticalFlex>
      ),
    },
    {
      width: 150,
      text: "주문코드",
      code: "id",
      Cell: ({ cell }) => (
        <ToolTip
          style={{ width: "max-content", zIndex: 10, backgroundColor: "white" }}
          title={<P>{cell}</P>}
        >
          <P ellipsis width={150}>
            {cell}
          </P>
        </ToolTip>
      ),
    },
    {
      width: 100,
      text: "주문자",
      code: "customer",
      Cell: ({ cell }) => (
        <VerticalFlex flexStart>
          <ToolTip
            style={{
              width: "max-content",
              zIndex: 10,
              backgroundColor: "white",
            }}
            title={
              <P>{`${cell?.first_name && cell.first_name}${
                cell?.first_name && cell?.last_name ? " " : ""
              }`}</P>
            }
          >
            <P width={100} ellipsis>
              {`${cell?.first_name && cell.first_name}${
                cell?.first_name && cell?.last_name ? " " : ""
              }`}
            </P>
          </ToolTip>

          <ToolTip
            style={{
              width: "max-content",
              zIndex: 10,
              backgroundColor: "white",
            }}
            title={<P>{`(${cell.email})`}</P>}
          >
            <P width={100} ellipsis>{`(${cell.email})`}</P>
          </ToolTip>
        </VerticalFlex>
      ),
    },
    {
      width: 80,
      text: "등급",
      code: "groups",
      Cell: ({ cell }) => cell?.[0]?.name || "사업자회원",
    },
    {
      width: 400,
      text: "상품명",
      justifyContent: "flex-start",
      code: "items",
      Cell: ({ cell }) => (
        <FlexGrid columns={2} width="max-content" gap={10} rows={cell.length}>
          {cell
            .sort((a1, a2) =>
              a1?.variant?.product?.title.localeCompare(
                a2?.variant?.product?.title
              )
            )
            ?.map((item) => (
              <>
                <FlexChild width="max-content" key={`${item.id}_title`}>
                  <P
                    width={350}
                    ellipsis
                  >{`${item?.title} ${item.variant?.title}`}</P>
                </FlexChild>
                <FlexChild width="max-content" key={`${item.id}_quantity`}>
                  <P width={50} ellipsis>{`x ${item.quantity}`}</P>
                </FlexChild>
              </>
            ))}
        </FlexGrid>
      ),
    },
    {
      width: 140,
      text: "배송정보",
      justifyContent: "flex-start",
      code: "shipping_address",
      Cell: ({ row, cell }) => (
        <ToolTip
          style={{
            zIndex: 10,
            width: "max-content",
            padding: 10,
            backgroundColor: "white",
            border: "1px solid black",
          }}
          title={
            <VerticalFlex
              backgroundColor="white"
              // width={300}
              flexStart
              padding={10}
            >
              <P width="max-content">
                {`${cell?.company ? cell.company : ""}${
                  cell?.company &&
                  cell?.company !== "default" &&
                  (cell?.first_name || cell?.last_name)
                    ? " "
                    : ""
                }${
                  cell?.first_name || cell?.last_name
                    ? `${cell?.first_name && cell.first_name}${
                        cell.first_name && cell.last_name ? " " : ""
                      }${cell.last_name ? cell.last_name : ""}`
                    : ""
                }`.replace("default ", "")}
              </P>
              <P>
                {`${cell?.postal_code ? `(${cell.postal_code})` : ""}${
                  cell?.postal_code && (cell?.address_1 || cell.address_2)
                    ? " "
                    : ""
                }${cell?.address_1 ? cell.address_1 : ""}${
                  cell.address_1 && cell.address_2 ? " " : ""
                }${cell?.address_2 ? cell.address_2 : ""}`}
              </P>
            </VerticalFlex>
          }
        >
          <VerticalFlex>
            <P ellipsis width={140}>
              {`${cell?.company ? cell.company : ""}${
                cell?.company && (cell?.first_name || cell?.last_name)
                  ? " "
                  : ""
              }${
                cell?.first_name || cell?.last_name
                  ? `${cell?.first_name && cell.first_name}${
                      cell.first_name && cell.last_name ? " " : ""
                    }${cell.last_name ? cell.last_name : ""}`
                  : ""
              }`.replace("default ", "")}
            </P>
            <P ellipsis width={140}>
              {`${cell?.postal_code ? `(${cell.postal_code})` : ""}${
                cell?.postal_code && (cell?.address_1 || cell.address_2)
                  ? " "
                  : ""
              }${cell?.address_1 ? cell.address_1 : ""}${
                cell.address_1 && cell.address_2 ? " " : ""
              }${cell?.address_2 ? cell.address_2 : ""}`}
            </P>
          </VerticalFlex>
        </ToolTip>
      ),
    },
    {
      width: 100,
      text: "배송메시지",
      code: "message",
      // Cell: ({ cell }) => (cell ? cell : "없음"),
      Cell: ({ cell }) =>
        cell ? (
          <ToolTip
            style={{
              width: "max-content",
              zIndex: 10,
              backgroundColor: "white",
            }}
            title={<P ellipsis>{cell}</P>}
          >
            <P width={100} ellipsis>
              {cell}
            </P>
          </ToolTip>
        ) : (
          "없음"
        ),
    },
    {
      width: 80,
      text: "구매금액",
      justifyContent: "flex-end",
      code: "payments",
      Cell: ({ cell }) =>
        Number(cell?.[0]?.amount || 0).toLocaleString("ko-kr"),
    },
    {
      width: 100,
      text: "상태",
      Cell: ({ row }) => {
        switch (row.status) {
          case "pending": {
            switch (row.payment_status) {
              case "awaiting":
                return "입금 대기";
              default: {
                switch (row.fulfillment_status) {
                  case "not_fulfilled":
                    return "상품 준비";

                  case "fulfilled":
                    return "배송 대기";

                  case "partially_shipped":
                    return "배송 중";

                  default:
                    return "기타";
                }
              }
            }
          }
          case "completed":
            return "배송 완료";
          case "canceled": {
            switch (row.payment_status) {
              case "canceled":
                return "취소 완료";
              default:
                return "취소 신청";
            }
          }
          case "exchange": {
            switch (row.fulfillment_status) {
              default:
                return "교환신청";
              case "returned":
                return "반품됨";
              case "partially_returned":
                return "배송완료 및 미반품";
              case "shipped":
                return "배송 및 교환완료";
            }
          }
          case "refund": {
            switch (row.payment_status) {
              case "refunded": {
                switch (row.fulfillment_status) {
                  case "returned":
                    return "환불완료";
                  default:
                    return "환불완료 및 미반품";
                }
              }
              default: {
                switch (row.fulfillment_status) {
                  case "returned":
                    return "물품반납 및 미환불";
                  default:
                    return "환불신청";
                }
              }
            }
          }
          default: {
            return "기타";
          }
        }
      },
    },
    {
      width: 120,
      text: "운송장번호",
      code: "metadata",
      Cell: ({ cell }) => {
        if (cell.shipping === "null") cell.shipping = null;
        return (
          <P
            hover
            cursor
            onClick={() => {
              const trackingNumber = cell?.shipping; // 운송장 번호 가져오기
              if (!trackingNumber) {
                toast.error(t("운송장 번호가 존재하지 않습니다."), {
                  autoClose: 1000,
                  position: toast.POSITION.BOTTOM_CENTER,
                });
                return;
              } else {
                const trackingUrl = `https://trace.cjlogistics.com/next/tracking.html?wblNo=${trackingNumber.replaceAll(
                  "-",
                  ""
                )}`;

                // 팝업창 옵션 설정
                const popupOptions =
                  "width=800,height=800,scrollbars=yes,resizable=yes";

                // 팝업창 열기
                window.open(trackingUrl, "ShippingStatusPopup", popupOptions);
              }
            }}
          >
            {cell?.shipping ? cell.shipping : "데이터 없음"}
          </P>
        );
      },
    },
    {
      width: 200,
      text: "메모",
      code: "metadata",
      Cell: ({ cell }) => (
        <P color={cell?.memo && "red"} width={180}>
          {cell?.memo || "없음"}
        </P>
      ),
    },
  ];
  const headers2 = [
    {
      width: 50,
      label: "No.",
      code: "index",
      Cell: ({ index }) => index + 1,
    },
    {
      width: 200,
      label: "포인트",
      code: "metadata",
      Cell: ({ cell }) => Number(cell.point || 0),
    },
    {
      width: 200,
      label: "누적포인트",
      code: "metadata",
      Cell: ({ cell }) => Number(cell.total || 0),
    },
    {
      width: 150,
      label: "날짜",
      code: "created_at",
      Cell: ({ cell }) => (cell ? getDate(cell) : "오류"),
    },
    {
      label: "메모",
      code: "metadata",
      Cell: ({ cell }) => cell?.memo,
    },
  ];

  return (
    <ModalBase
      borderRadius={"10px"}
      headerStyle
      ref={modal}
      width={width}
      height={height}
      withHeader={withHeader}
      withFooter={withFooter}
      withCloseButton={withCloseButton}
      clickOutsideToClose={clickOutsideToClose}
      title={title}
      buttonText={buttonText}
    >
      <div style={{ overflow: "scroll", height: "75vh" }}>
        <Container maxWidth={1800}>
          <VerticalFlex gap={20}>
            <HorizontalFlex>
              <FlexChild width="max-content">
                <Inline>
                  <P weight="bold" size={20}>
                    개인정보
                  </P>
                  <P
                    textHover
                    cursor
                    onClick={() => {
                      folds[0] = !folds[0];
                      setFolds([...folds]);
                    }}
                    style={{
                      webkitYserSelect: "none",
                      mozUserSelect: "none",
                      msUseSelect: "none",
                      userSelect: "none",
                      paddingLeft: 5,
                    }}
                    size="12"
                  >
                    {folds[0] ? "[펴기]" : "[접기]"}
                  </P>
                </Inline>
              </FlexChild>
            </HorizontalFlex>
            {!folds[0] && (
              <FlexChild>
                <div className={style.container} sty>
                  <VerticalFlex>
                    <FlexChild>
                      <div className={style.contentWrap}>
                        <VerticalFlex gap={20}>
                          <FlexChild>
                            <HorizontalFlex
                              gap={40}
                              justifyContent="flex-start"
                            >
                              <FlexChild width={"15%"}>
                                <P>이메일(아이디)</P>
                              </FlexChild>
                              <FlexChild width="max-content">
                                <P>{data?.email}</P>
                              </FlexChild>
                            </HorizontalFlex>
                          </FlexChild>
                          <FlexChild>
                            <HorizontalFlex
                              gap={40}
                              justifyContent="flex-start"
                            >
                              <FlexChild width={"15%"}>
                                <P>이름</P>
                              </FlexChild>
                              <FlexChild width="max-content">
                                <P>{data?.first_name}</P>
                              </FlexChild>
                            </HorizontalFlex>
                          </FlexChild>
                          <FlexChild>
                            <HorizontalFlex
                              gap={40}
                              justifyContent="flex-start"
                            >
                              <FlexChild width={"15%"}>
                                <P>휴대폰번호</P>
                              </FlexChild>
                              <FlexChild width="max-content">
                                <P>{data?.phone}</P>
                              </FlexChild>
                            </HorizontalFlex>
                          </FlexChild>
                          <FlexChild>
                            <HorizontalFlex
                              gap={40}
                              justifyContent="flex-start"
                            >
                              <FlexChild width={"15%"}>
                                <P>포인트</P>
                              </FlexChild>
                              <FlexChild width="max-content">
                                <P>{data?.point}</P>
                              </FlexChild>
                            </HorizontalFlex>
                          </FlexChild>
                        </VerticalFlex>
                      </div>
                    </FlexChild>
                  </VerticalFlex>
                </div>
              </FlexChild>
            )}
            <HorizontalFlex>
              <FlexChild width="max-content">
                <Inline>
                  <P weight="bold" size={20}>
                    사업자정보
                  </P>
                  <P
                    textHover
                    cursor
                    onClick={() => {
                      folds[1] = !folds[1];
                      setFolds([...folds]);
                    }}
                    style={{
                      webkitYserSelect: "none",
                      mozUserSelect: "none",
                      msUseSelect: "none",
                      userSelect: "none",
                      paddingLeft: 5,
                    }}
                    size="12"
                  >
                    {folds[1] ? "[펴기]" : "[접기]"}
                  </P>
                </Inline>
              </FlexChild>
            </HorizontalFlex>
            {!folds[1] && (
              <FlexChild>
                <div className={style.container}>
                  <VerticalFlex>
                    <FlexChild>
                      <div className={style.contentWrap}>
                        <VerticalFlex gap={20}>
                          <FlexChild>
                            <HorizontalFlex
                              gap={40}
                              justifyContent="flex-start"
                            >
                              <FlexChild width={"15%"}>
                                <P>상호</P>
                              </FlexChild>
                              <FlexChild width="max-content">
                                <P>{data?.businessMutual}</P>
                              </FlexChild>
                            </HorizontalFlex>
                          </FlexChild>
                          <FlexChild>
                            <HorizontalFlex
                              gap={40}
                              justifyContent="flex-start"
                            >
                              <FlexChild width={"15%"}>
                                <P>사업자 번호</P>
                              </FlexChild>
                              <FlexChild width="max-content">
                                <P>{data?.businessNumber}</P>
                              </FlexChild>
                            </HorizontalFlex>
                          </FlexChild>
                          <FlexChild>
                            <HorizontalFlex
                              gap={40}
                              justifyContent="flex-start"
                            >
                              <FlexChild width={"15%"}>
                                <P>주소</P>
                              </FlexChild>
                              <FlexChild width="max-content">
                                <P>{data?.businessAddress}</P>
                              </FlexChild>
                            </HorizontalFlex>
                          </FlexChild>
                          <FlexChild>
                            <HorizontalFlex
                              gap={40}
                              justifyContent="flex-start"
                            >
                              <FlexChild width={"15%"}>
                                <P>대표자 이름</P>
                              </FlexChild>
                              <FlexChild width="max-content">
                                <P>{data?.businessName}</P>
                              </FlexChild>
                            </HorizontalFlex>
                          </FlexChild>
                          <FlexChild>
                            <HorizontalFlex
                              gap={40}
                              justifyContent="flex-start"
                            >
                              <FlexChild width={"15%"}>
                                <P>대표 전화번호</P>
                              </FlexChild>
                              <FlexChild width="max-content">
                                <P>{data?.businessPhone}</P>
                              </FlexChild>
                            </HorizontalFlex>
                          </FlexChild>
                          <FlexChild>
                            <HorizontalFlex
                              gap={40}
                              justifyContent="flex-start"
                            >
                              <FlexChild width={"15%"}>
                                <P>대표 이메일</P>
                              </FlexChild>
                              <FlexChild width="max-content">
                                <P>{data?.businessEmail}</P>
                              </FlexChild>
                            </HorizontalFlex>
                          </FlexChild>
                          <FlexChild>
                            <HorizontalFlex
                              gap={40}
                              justifyContent="flex-start"
                            >
                              <FlexChild width={"15%"}>
                                <P>업종</P>
                              </FlexChild>
                              <FlexChild width="max-content">
                                <P>{data?.businessDetail}</P>
                              </FlexChild>
                            </HorizontalFlex>
                          </FlexChild>
                          <FlexChild>
                            <HorizontalFlex
                              gap={40}
                              justifyContent="flex-start"
                            >
                              <FlexChild width={"15%"}>
                                <P>업태</P>
                              </FlexChild>
                              <FlexChild width="max-content">
                                <P>{data?.businessType}</P>
                              </FlexChild>
                            </HorizontalFlex>
                          </FlexChild>
                          <FlexChild>
                            <HorizontalFlex
                              gap={40}
                              justifyContent="flex-start"
                            >
                              <FlexChild width={"15%"}>
                                <P>사업자 등록증</P>
                              </FlexChild>
                              <FlexChild width="max-content">
                                <ToolTip
                                  style={{ bottom: 10 }}
                                  title={
                                    <AdminImage
                                      src={data.businessCertificate}
                                      size={"30vh"}
                                    />
                                  }
                                >
                                  <AdminImage
                                    src={data.businessCertificate}
                                    size={100}
                                  />
                                </ToolTip>
                              </FlexChild>
                            </HorizontalFlex>
                          </FlexChild>
                          <FlexChild>
                            <HorizontalFlex
                              gap={40}
                              justifyContent="flex-start"
                            >
                              <FlexChild width={"15%"}>
                                <P>소매인 지정서</P>
                              </FlexChild>
                              <FlexChild width="max-content">
                                <ToolTip
                                  style={{ bottom: 10 }}
                                  title={
                                    <AdminImage
                                      src={data.businessRetail}
                                      size={"30vh"}
                                    />
                                  }
                                >
                                  <AdminImage
                                    src={data.businessRetail}
                                    size={100}
                                  />
                                </ToolTip>
                              </FlexChild>
                            </HorizontalFlex>
                          </FlexChild>
                        </VerticalFlex>
                      </div>
                    </FlexChild>
                  </VerticalFlex>
                </div>
              </FlexChild>
            )}

            <HorizontalFlex justifyContent="flex-start" gap={10}>
              <FlexChild width="max-content">
                <Inline>
                  <P weight="bold" size={20}>
                    포인트 기록
                  </P>
                  <P
                    textHover
                    cursor
                    onClick={() => {
                      folds[2] = !folds[2];
                      setFolds([...folds]);
                    }}
                    style={{
                      webkitYserSelect: "none",
                      mozUserSelect: "none",
                      msUseSelect: "none",
                      userSelect: "none",
                      paddingLeft: 5,
                    }}
                    size="12"
                  >
                    {folds[2] ? "[펴기]" : "[접기]"}
                  </P>
                </Inline>
              </FlexChild>
              <FlexChild width="max-content">
                <AdminCustomButton
                  text="추가"
                  onClick={() =>
                    NiceModal.show("addPoint", {
                      id: data.id,
                      email: data.email,
                      name: `${data?.first_name ? data.first_name : ""}${
                        data?.first_name && data.last_name ? " " : ""
                      }${data?.last_name ? data.last_name : ""}`,
                      point: data.point,
                      setReload: (value) => {
                        setReload(value);
                        onSuccess?.();
                      },
                    })
                  }
                />
              </FlexChild>
            </HorizontalFlex>
            {!folds[2] && (
              <FlexChild>
                <div className={style.container}>
                  <VerticalFlex>
                    <FlexChild>
                      <div
                        className={style.contentWrap}
                        style={{ height: "300px", overflowY: "auto" }}
                      >
                        <VerticalFlex gap={10} height="100%">
                          <FlexChild height="max-content">
                            <HorizontalFlex>
                              {headers2?.map((header, index) => (
                                <FlexChild
                                  key={`${header?.label}_${index}`}
                                  width={header?.width ? header.width : null}
                                >
                                  <P weight="bold">{header?.label}</P>
                                </FlexChild>
                              ))}
                            </HorizontalFlex>
                          </FlexChild>
                          <FlexChild height="max-content">
                            <VerticalFlex gap={10}>
                              {logs?.map((d, rowIndex) => {
                                return (
                                  <HorizontalFlex key={d?.label}>
                                    {headers2.map((header, index) => {
                                      let value = header?.Cell
                                        ? header.Cell({
                                            cell: d[header?.code],
                                            row: d,
                                            index: rowIndex,
                                          })
                                        : header?.code
                                        ? d[header.code]
                                        : "-";

                                      if (
                                        typeof value === "string" ||
                                        typeof value === "number"
                                      )
                                        value = <P>{value}</P>;
                                      return (
                                        <FlexChild
                                          key={`${header.label}_${index}_column`}
                                          width={header?.width}
                                        >
                                          {value}
                                        </FlexChild>
                                      );
                                    })}
                                  </HorizontalFlex>
                                );
                              })}
                            </VerticalFlex>
                          </FlexChild>
                        </VerticalFlex>
                      </div>
                    </FlexChild>
                  </VerticalFlex>
                </div>
              </FlexChild>
            )}

            <HorizontalFlex gap={10}>
              <FlexChild width="max-content">
                <Inline>
                  <P weight="bold" size={20}>
                    주문 목록
                  </P>
                  <P
                    textHover
                    cursor
                    onClick={() => {
                      folds[3] = !folds[3];
                      setFolds([...folds]);
                    }}
                    style={{
                      webkitYserSelect: "none",
                      mozUserSelect: "none",
                      msUseSelect: "none",
                      userSelect: "none",
                      paddingLeft: 5,
                    }}
                    size="12"
                  >
                    {folds[3] ? "[펴기]" : "[접기]"}
                  </P>
                </Inline>
              </FlexChild>
              <FlexChild>
                <select
                  value={limit}
                  onChange={(e) => setLimit(Number(e.target.value))}
                >
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                  <option value={200}>200</option>
                </select>
              </FlexChild>
            </HorizontalFlex>
            {!folds[3] && (
              <FlexChild>
                <div className={style.container}>
                  <VerticalFlex>
                    <FlexChild>
                      <div className={style.contentWrap}>
                        {orders?.length > 0 ? (
                          <>
                            <FlexChild>
                              <HorizontalFlex
                                justifyContent="flex-start"
                                gap={30}
                              >
                                {headers.map((header, index) => (
                                  <FlexChild
                                    key={`header_${index}_${header.text}`}
                                    width={header?.width}
                                  >
                                    <P>{header?.text}</P>
                                  </FlexChild>
                                ))}
                              </HorizontalFlex>
                            </FlexChild>
                            <FlexChild padding={"10px 0px 10px 0px"}>
                              <div
                                style={{
                                  borderBottom: "1px solid #a0a0a0",
                                }}
                              />
                            </FlexChild>
                            {orders?.map((order, oindex) => (
                              <FlexChild key={order.id}>
                                {oindex > 0 && (
                                  <FlexChild padding={"10px 0px 10px 0px"}>
                                    <div
                                      style={{
                                        borderBottom: "1px solid #a0a0a0",
                                      }}
                                    />
                                  </FlexChild>
                                )}
                                <HorizontalFlex
                                  justifyContent="flex-start"
                                  alignItems="flex-start"
                                  gap={30}
                                >
                                  {headers?.map((header, index) => {
                                    let value;
                                    if (header?.Cell) {
                                      value = header?.Cell({
                                        index: oindex,
                                        cell: order?.[header.code],
                                        row: order,
                                      });
                                    } else value = order?.[header.code];
                                    if (!value && value !== 0)
                                      value = "데이터 없음";
                                    if (
                                      typeof value === "string" ||
                                      typeof value === "number"
                                    )
                                      value = <P>{value}</P>;

                                    return (
                                      <FlexChild
                                        key={`col_${index}_${order?.id}_${header.text}`}
                                        width={header.width}
                                        justifyContent={header.justifyContent}
                                      >
                                        {value}
                                      </FlexChild>
                                    );
                                  })}
                                </HorizontalFlex>
                              </FlexChild>
                            ))}
                          </>
                        ) : (
                          <FlexChild>
                            <P>주문 목록이 없습니다.</P>
                          </FlexChild>
                        )}
                      </div>
                    </FlexChild>
                  </VerticalFlex>
                </div>
              </FlexChild>
            )}

            {!folds[3] && setPage && max > 1 && (
              <HorizontalFlex gap={30} width="max-content">
                <Move
                  name="《"
                  onClick={() =>
                    setPage(
                      Math.max(
                        0,
                        page % 10 >= 1
                          ? page - (page % 10)
                          : page - 10 - (page % 10)
                      )
                    )
                  }
                  disabled={page === 0}
                />
                <Move
                  name="〈"
                  onClick={() => setPage(Math.max(0, page - 1))}
                  disabled={page === 0}
                />
                <Page page={page} maxPage={max} setPage={setPage} />
                <Move
                  name="〉"
                  disabled={page === Math.ceil(max - 1)}
                  onClick={() =>
                    setPage(Math.min(Math.ceil(max - 1), page + 1))
                  }
                />
                <Move
                  name="》"
                  disabled={page === Math.ceil(max - 1)}
                  onClick={() =>
                    setPage(
                      Math.min(
                        Math.ceil(max - 1),
                        page % 10 < 9
                          ? page + 9 - (page % 10)
                          : page + 10 - (page % 10)
                      )
                    )
                  }
                />
              </HorizontalFlex>
            )}

            <FlexChild width="max-content">
              <AdminCustomButton
                style={buttonStyle.white_border}
                text={"닫기"}
                onClick={onCloseClick}
              />
            </FlexChild>
          </VerticalFlex>
        </Container>
      </div>
    </ModalBase>
  );
});

export default CustomerStatusModal;
const Page = ({ page, maxPage, setPage }) => {
  const start = page - (page % 10);
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
    .map((n) => start + n)
    .filter((n) => n < maxPage)
    .map((n) => (
      <FlexChild>
        <AdminCustomButton
          style={{ wordBreak: "keep-all" }}
          selected={n === page}
          onClick={() => setPage(n)}
          text={n + 1}
        />
      </FlexChild>
    ));
};
const Move = ({ name, onClick, disabled }) => {
  return (
    <FlexChild>
      <AdminCustomButton onClick={onClick} disabled={disabled} text={name} />
    </FlexChild>
  );
};
